(function () {
  if (customElements.get('card-product-form')) return;

  class CardProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      const stop = (e) => e.stopPropagation();
      ['click', 'mousedown', 'mouseup', 'touchstart'].forEach((evt) => {
        this.addEventListener(evt, stop);
      });
      this.variantData = JSON.parse(this.querySelector('.card-variant-data').textContent);
      this.idInput = this.querySelector('.card-variant-id');
      this.optionSelects = Array.from(this.querySelectorAll('.card-option-select'));
      this.qtyInput = this.querySelector('.card-qty-input');
      this.amountEl = this.querySelector('[data-card-amount]');
      this.priceEl = this.querySelector('[data-card-price]');
      this.addBtn = this.querySelector('.card-add-to-cart');
      this.addText = this.querySelector('.card-add-text');
      this.minusBtn = this.querySelector('.quantity__button[name="minus"]');
      this.plusBtn = this.querySelector('.quantity__button[name="plus"]');
      this.step = parseInt((this.qtyInput && this.qtyInput.dataset.step) || '100', 10) || 100;

      this.optionSelects.forEach((s) => s.addEventListener('change', () => this.onVariantChange()));

      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); this.changeQty(-this.step); }, true);
      }
      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); this.changeQty(this.step); }, true);
      }
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => { this.normalizeQty(); this.updateAmount(); });
        this.qtyInput.addEventListener('input', () => this.updateAmount());
      }

      // Offer tooltip toggle
      this.offerTrigger = this.querySelector('.card-offer-trigger');
      this.offerTooltip = this.querySelector('.card-offer-tooltip');
        if (this.offerTrigger && this.offerTooltip) {
          this.offerTrigger.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.offerTooltip.hidden = !this.offerTooltip.hidden;
          });
          this.offerTrigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.offerTooltip.hidden = !this.offerTooltip.hidden;
            }
          });
          // Bahar click karne pe band ho jaye
          document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) this.offerTooltip.hidden = true;
          });
        }

      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.onVariantChange();
    }

    changeQty(delta) {
      let val = (parseInt(this.qtyInput.value, 10) || this.step) + delta;
      if (val < this.step) val = this.step;
      this.qtyInput.value = val;
      this.updateAmount();
    }

    normalizeQty() {
      const raw = this.qtyInput.value.trim();
      if (raw === '') return;                    // blank hai to kuch mat karo
      let val = parseInt(raw, 10);
      if (isNaN(val)) return;                     // invalid ho to bhi chhod do
      if (val < this.step) val = this.step;
      val = Math.round(val / this.step) * this.step;
      if (val < this.step) val = this.step;
      this.qtyInput.value = val;
    }

    getSelected() {
      return this.optionSelects
        .slice()
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((s) => s.value);
    }

    getCurrentVariant() {
      if (this.optionSelects.length === 0) return this.variantData[0];
      const sel = this.getSelected();
      return this.variantData.find((v) => v.options.every((o, i) => o === sel[i]));
    }

    onVariantChange() {
      this.currentVariant = this.getCurrentVariant();
      if (!this.currentVariant) {
        this.idInput.value = '';
        this.addBtn.setAttribute('disabled', 'disabled');
        this.addText.textContent = 'Unavailable';
        if (this.amountEl) this.amountEl.textContent = '—';
        return;
      }
      this.idInput.value = this.currentVariant.id;
      if (this.currentVariant.available) {
        this.addBtn.removeAttribute('disabled');
        this.addText.textContent = 'Add to Cart';
      } else {
        this.addBtn.setAttribute('disabled', 'disabled');
        this.addText.textContent = 'Sold out';
      }
      this.updatePrice();
      this.updateAmount();
    }

    updatePrice() {
      if (!this.priceEl || !this.currentVariant) return;
      this.priceEl.textContent = this.formatMoney(this.currentVariant.price);
    }

    updateAmount() {
      if (!this.amountEl || !this.currentVariant) return;
      const qty = parseInt((this.qtyInput && this.qtyInput.value), 10) || this.step;
      this.amountEl.textContent = this.formatMoney(this.currentVariant.price * qty);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return 'Rs. ' + amount;
    }

    async onSubmit(e) {
      e.preventDefault();
      if (this.addBtn.hasAttribute('disabled')) return;

      // Blank / invalid quantity check
      const rawQty = this.qtyInput ? this.qtyInput.value.trim() : '';
      if (rawQty === '' || parseInt(rawQty, 10) < this.step) {
        this.qtyInput.setCustomValidity('Enter the quantity');
        this.qtyInput.reportValidity();
        this.qtyInput.focus();
        return;
      }
      this.qtyInput.setCustomValidity('');

      this.normalizeQty();
      this.addBtn.classList.add('loading');
      this.addBtn.setAttribute('disabled', 'disabled');

      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: this.currentVariant.id,
            quantity: parseInt(this.qtyInput.value, 10) || this.step,
          }),
        });
        const data = await res.json();

        if (data.status) {
          this.addText.textContent = 'Error';
          setTimeout(() => this.onVariantChange(), 2000);
          return;
        }

        await this.refreshCartCount();
        this.addText.textContent = 'Added';
        setTimeout(() => this.onVariantChange(), 1500);
      } catch (err) {
        console.error(err);
        this.addText.textContent = 'Error';
        setTimeout(() => this.onVariantChange(), 2000);
      } finally {
        this.addBtn.classList.remove('loading');
        this.addBtn.removeAttribute('disabled');
      }
    }

    async refreshCartCount() {
      try {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const res = await fetch(cartUrl + '?section_id=cart-icon-bubble');
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const fresh = html.querySelector('.shopify-section') || html.body.firstElementChild;
        const current = document.getElementById('cart-icon-bubble');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      } catch (e) {}

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'card-product-form' });
      }
    }
  }

  customElements.define('card-product-form', CardProductForm);
})();